import React from 'react';
import { Dialog } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default function DeleteDialog(props) {
  const {
    show,
    onClose,
    rsrc,
    onDelete
  } = props;
  const onOkay = async () => {
    await onDelete(rsrc);
    onClose();
  };
  if (!Array.isArray(rsrc) || rsrc.length === 0) {
    return null;
  }
  if (rsrc.length === 1) {
    return /*#__PURE__*/_jsx(Dialog.Question, {
      onOkay: onOkay,
      onCancel: onClose,
      show: show,
      title: "Delete Rsrc",
      okay: "Delete",
      okayVariant: "primaryDestructive",
      message: `Are you sure you want to delete the rsrc at path ${rsrc[0].data.path}? This action is permanent and cannot be undone.`
    });
  }
  return /*#__PURE__*/_jsx(Dialog.Question, {
    onOkay: onOkay,
    onCancel: onClose,
    show: show,
    title: "Delete Rsrc",
    okay: "Delete",
    okayVariant: "primaryDestructive",
    message: `Are you sure you want to delete (${rsrc.length}) rsrcs with the paths ${rsrc.map(r => r.data.path).join(', ')}? This action is permanent and cannot be undone.`
  });
}